import classnames from 'classnames';
import React, { useContext } from 'react';
import styled, { ThemeContext, ThemeProvider } from 'styled-components';
import { TooltipLooks, TooltipPositions } from '../../../../enums/tooltip.js';
import '../../../../styles/styled-components/alert.js';
import '../../../../styles/styled-components/animations.js';
import '../../../../styles/styled-components/box-shadow.js';
import '../../../../styles/styled-components/button.js';
import '../../../../themes/alert.js';
import '../../../../themes/button.js';
import '../../../../themes/checkbox.js';
import '../../../../themes/divider.js';
import '../../../../themes/dropdown.js';
import '../../../../themes/fieldset.js';
import '../../../../themes/input.js';
import '../../../../themes/list.js';
import '../../../../themes/listbox.js';
import '../../../../themes/loader.js';
import '../../../../themes/option.js';
import '../../../../themes/popout.js';
import '../../../../themes/switch.js';
import { lightTheme } from '../../../../themes/themes.js';
import '../../../../themes/tooltip.js';
import '../../../../styles/styled-components/font-face.js';
import '../../../../styles/styled-components/global.js';
import '../../../../styles/styled-components/input.js';
import '../../../../styles/styled-components/list.js';
import '../../../../styles/styled-components/listitem.js';
import '../../../../styles/styled-components/media-queries.js';
import '../../../../styles/styled-components/reset.js';
import '../../../../styles/styled-components/outline.js';
import '../../../../styles/styled-components/popout.js';
import '../../../../styles/styled-components/screen-reader.js';
import '../../../../styles/styled-components/switch.js';
import { baseTooltipStyle, getTooltipPosition } from '../../../../styles/styled-components/tooltip.js';

const BaseHoverTooltip = (props)=>{
    const { children, className, look, position, text, ...otherProps } = props;
    return /*#__PURE__*/ React.createElement("span", {
        ...otherProps,
        className: classnames({
            'bf-tooltip': true,
            'bf-tooltip__hover': true,
            [`bf-tooltip__hover--${look}`]: true,
            [`bf-tooltip__hover--${position}`]: true,
            [`${className}`]: !!className
        }),
        "data-tooltip": text
    }, children);
};
const Tooltip = styled(BaseHoverTooltip)`
  ${baseTooltipStyle}
  ${({ look, position })=>getTooltipPosition({
        look,
        position
    })}
`;
/**
 * A tooltip that only display on cursor `:hover`. This will not display on touch devices.
 * Because of CSS tooltip limitations, text should be kept short.
 *
 * IMPORTANT: This component is NOT considered accessible and should only be used
 * for decoration (to display non-critical information). If you're adding a tooltip
 * to a `<button>`, `<input>`, or other focusable element, use `<StandardTooltip>` instead.
 * If you need lengthy supplemental information, consider using a `<StandardPopout>`.
 *
 * Child elements should have appropriate `aria-label`, `title`, `<OnlyForScreenReader>`, or visible text.
 *
 * @param props HoverTooltipProps
 * @returns FunctionComponent<HoverTooltipProps>
 */ const HoverTooltip = (props)=>{
    const { look = TooltipLooks.Default, position = TooltipPositions.Top } = props;
    const themeContext = useContext(ThemeContext);
    return /*#__PURE__*/ React.createElement(ThemeProvider, {
        theme: themeContext || lightTheme
    }, /*#__PURE__*/ React.createElement(Tooltip, {
        ...props,
        look: look,
        position: position
    }));
};

export { HoverTooltip };
//# sourceMappingURL=hover-tooltip.js.map
